<div #svgContainer class='image-cropper-svg-container'></div>


// WEBPACK FOOTER //
// ./src/app/controls/image-cropper/image-cropper.component.ts.ImageCropperComponent.html